"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TreningPrzygodaWTajlandii() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="trening-przygoda-w-tajlandii" className="relative w-full min-h-[50vh] sm:min-h-[90vh] flex flex-col items-center justify-start overflow-visible sm:overflow-hidden pt-[55vh] sm:pt-[60vh] pb-16 bg-cover bg-center bg-no-repeat bg-scroll bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583198/img/image_d4kkxivc.png)] sm:bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583198/img/image_tn02see0.png)]">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col items-center justify-center gap-8 mb-12">
          <Badge variant="outline" className="border-primary/30 bg-primary/5 text-primary px-4 py-1 uppercase tracking-widest text-xs font-bold backdrop-blur-sm">
            17-28 Sierpnia • Koh Samui
          </Badge>
          <Button asChild size="lg" className="rounded-full bg-gradient-to-r from-[hsl(25,95%,55%)] to-[hsl(15,90%,45%)] hover:shadow-[0_0_20px_rgba(251,146,60,0.4)] transition-all duration-300 px-10 py-7 text-lg font-black uppercase tracking-tighter shadow-lg">
            <Link to="#zarezerwuj-swoje-miejsce">Zapisz się na obóz</Link>
          </Button>
        </div>
      </div>
    </section>;
}